import React, { FC } from 'react';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { INDUSTRIES } from '@common/types';
import MultiSelectionFilter from '@components/Templates/FilterPanel/MultiSelectionFilter';

type Props = {};

const IndustriesFilter: FC<Props> = ({}) => {
  const {
    state: { filters },
  } = useTemplatesContext();

  return (
    <MultiSelectionFilter
      selectedValue={filters.industries}
      items={INDUSTRIES}
      langTokenPrefix={'marketplace.templates-page.industry-'}
      updatedQueryParam={'industries'}
      dataHook={'industries'}
      type={'industry'}
    />
  );
};

export default IndustriesFilter;
